import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";

export const LinkColumn = ({ children }: PropsWithChildren) => {
    return (
        <div
            css={[
                css({
                    display: "flex",
                    flexDirection: "column"
                }),
                navColumnHeaderStyles
            ]}
        >
            {children}
        </div>
    );
};

const navColumnHeaderStyles = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h2.nav-column-header": {
        padding: 0,
        margin: 0,
        textTransform: "uppercase",
        color: wacToken("color.primary.black"),
        fontSize: "0.75rem",
        fontFamily: wacToken("font.charlie.text"),
        fontWeight: 700,
        lineHeight: "1rem"
    }
});
